import React from "react";
import styles from "./Subheading.module.scss";

export const Subheading = ({ children }) => {
  return <h3 className={[styles.subheading]}>{children}</h3>;
};
